import React, {useState} from 'react';
import './SectionBox.scss';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const SectionBox = ({label, children, expandedByDefault}) => {
  const [expanded, setExpanded] = useState(!!expandedByDefault);

  const toggleExpandSection = () => {
    setExpanded(!expanded);
  };

  return (
    <div className='SectionBox'>
      <div className='sectionBoxHeader'>
        <div className='expandButton' onClick={toggleExpandSection}>
          {expanded ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
        </div>
        {!!label && <div className='sectionBoxLabel' onClick={toggleExpandSection}>{label}</div>}
      </div>
      {!!expanded && children}
    </div>
  );
};

export default SectionBox;
